export default {
  home: {
    browseTopEvents: 'Near you this week',
    promotionEventsTitle: 'Best offers today',
    inspirationForYou: 'The most creative gift cards',
    kitsTitle: 'DIY kits for experiences at home',
    recommendedForYou: 'Try something new with our most popular experiences',
    newEventsForYou: 'New classes and workshops near you',
    lastViewedEvents: 'Continue where you left off',
    browseCategories: 'Find courses by category',
    header: {
      search: {
        selectCity: 'City',
      },
    },
    headerButtonTitle: 'Request an event',
  },
}
